import ActionType from './types';
import { ActionWithPayload } from '../utils/types';
import { Property } from './types';

export const startToFetchProperty = (): ActionWithPayload<
  ActionType.startToFetchProperty,
  {}
> => ({
  type: ActionType.startToFetchProperty,
  payload: {}
});

export const setProperty = (
  property: Property
): ActionWithPayload<ActionType.setProperty, Property> => ({
  type: ActionType.setProperty,
  payload: property
});

export const failedSetProperty = (): ActionWithPayload<
  ActionType.failedSetProperty,
  {}
> => ({
  type: ActionType.failedSetProperty,
  payload: {}
});

export const setUsageInfoId = (
  id: string
): ActionWithPayload<ActionType.setUsageInfoId, string> => ({
  type: ActionType.setUsageInfoId,
  payload: id
});

export const setOrganizationId = (
  id: string
): ActionWithPayload<ActionType.setOrganizationId, string> => ({
  type: ActionType.setOrganizationId,
  payload: id
});

export const setPeopleId = (
  id: string
): ActionWithPayload<ActionType.setPeopleId, string> => ({
  type: ActionType.setPeopleId,
  payload: id
});

export type PropertyAction =
  | ReturnType<typeof startToFetchProperty>
  | ReturnType<typeof setProperty>
  | ReturnType<typeof failedSetProperty>
  | ReturnType<typeof setUsageInfoId>
  | ReturnType<typeof setPeopleId>
  | ReturnType<typeof setOrganizationId>;
